import React from 'react';
import { Button, Card, InputNumber, Input, Space } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';

export interface QueryFilterValues {
  year: number;
  deptFrom: string;
  deptTo: string;
}

interface Props {
  values: QueryFilterValues;
  deptFromName: string;
  deptToName: string;
  loading: boolean;
  onChange: (field: keyof QueryFilterValues, value: string | number) => void;
  onDeptFromBlur: () => void;
  onDeptToBlur: () => void;
  onQuery: () => void;
  onReset: () => void;
}

/** Filter panel: year input + dept code range (FROM/TO). */
const QueryFilterPanel = React.memo<Props>(
  ({
    values,
    deptFromName,
    deptToName,
    loading,
    onChange,
    onDeptFromBlur,
    onDeptToBlur,
    onQuery,
    onReset,
  }) => (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Space wrap size="middle">
        <div>
          <label className="pw9324-filter-label">年度</label>
          <InputNumber
            value={values.year}
            min={1990}
            max={2099}
            step={1}
            onChange={v => onChange('year', v ?? new Date().getFullYear())}
            style={{ width: 100 }}
            placeholder="年份"
          />
        </div>

        <div>
          <label className="pw9324-filter-label">部門 [從]</label>
          <Input
            value={values.deptFrom}
            onChange={e => onChange('deptFrom', e.target.value)}
            onBlur={onDeptFromBlur}
            placeholder="起始部門代號"
            style={{ width: 130 }}
            allowClear
            addonAfter={deptFromName || undefined}
          />
        </div>

        <div>
          <label className="pw9324-filter-label">部門 [至]</label>
          <Input
            value={values.deptTo}
            onChange={e => onChange('deptTo', e.target.value)}
            onBlur={onDeptToBlur}
            placeholder="結束部門代號"
            style={{ width: 130 }}
            allowClear
            addonAfter={deptToName || undefined}
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'flex-end', paddingTop: 18 }}>
          <Space>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={onQuery}
              loading={loading}
            >
              查詢
            </Button>
            <Button icon={<ClearOutlined />} onClick={onReset}>
              清除
            </Button>
          </Space>
        </div>
      </Space>
    </Card>
  ),
);

QueryFilterPanel.displayName = 'QueryFilterPanel';

export default QueryFilterPanel;
